const routes = [
	{
		path: "/",
		component: () => import("layouts/LoginLayout.vue"),
		meta: {
			requiresAuth: false, // Do not require authentication.
		},
		children: [
			{
				// Isn't a standard page, doesn't use tm-page
				path: "/",
				component: () => import("pages/LoginPage.vue"),
			},
			{
				// Isn't a standard page, doesn't use tm-page
				path: "/forgot-password",
				component: () => import("pages/ForgotPasswordPage.vue"),
			},
			{
				// Isn't a standard page, doesn't use tm-page
				path: "/login",
				component: () => import("pages/LoginPage.vue"),
			},
			{
				// Isn't a standard page, doesn't use tm-page
				path: "/login-mfa",
				component: () => import("pages/LoginMFAPage.vue"),
			},
			{
				// Isn't a standard page, doesn't use tm-page
				path: "/login-password-change",
				component: () => import("pages/LoginPasswordChangePage.vue"),
			},
			{
				// Isn't a standard page, doesn't use tm-page
				path: "/mfa-setup",
				component: () => import("pages/MFASetupPage.vue"),
			},
			{
				// Isn't a standard page, doesn't use tm-page
				path: "/signup",
				component: () => import("pages/SignupPage.vue"),
			},
			{
				// Public terminal page after Microsoft 365 admin consent. Authenticated users (the
				// MSP) are forwarded to "/" so existing post-consent handling runs unchanged; a
				// third-party admin (emailed self-authorization link, no account) sees an "all set"
				// message instead of dead-ending on login.
				path: "/integration/complete",
				component: () => import("pages/IntegrationCompletePage.vue"),
			},
		],
	},
	{
		path: "/",
		component: () => import("layouts/ReportLayout.vue"),
		meta: {
			requiresAuth: true, // Require authentication.
		},
		children: [
			{
				path: "/report/print",
				component: () => import("pages/report/ReportPage.vue"),
			}
		],
	},
	{
		path: "/",
		component: () => import("layouts/MainLayout.vue"),
		meta: {
			requiresAuth: true, // Require authentication.
		},
		children: [
			{
				path: "/asset/detail/:assetId/agent/:assetagentId",
				component: () => import("src/pages/agent/AssetAgentDetailPage.vue"),
				meta: {
					title: "Agent Detail",
					icon: 'tm:detail',
					links: [
						{ label: 'Agent Health', to: '/asset/detail/:assetId/agent/:assetagentId/health' },
						{ to: '/internal-scan/subnet' },
					],
				}
			},
			{
				path: "/asset/detail/:assetId/agent/:assetagentId/health",
				component: () => import("src/pages/agent/AssetAgentDetailHealthPage.vue"),
				meta: {
					title: "Agent Health",
					icon: 'tm:health',
				}
			},
			{
				path: "/asset/detail/:assetId/agent/:assetagentId/task/:assetagenttaskId",
				component: () => import("src/pages/agent/AssetAgentTaskPage.vue"),
				meta: {
					title: "Task",
					icon: 'tm:task-active',
				}
			},
			{
				path: "/agent-hardware",
				component: () => import("src/pages/agent-hardware/AgentHardwarePage.vue"),
				meta: {
					title: "Agent Hardware",
					icon: "tm:hardware",
					description: "This page displays the registered Hardware Identifiers and their associated Tenants.",
					links: [
						{ to: '/device' },
					],
				}
			},
			{
				path: "/alert/:alertId",
				component: () => import("src/pages/alert/AlertIDPage.vue"),
				meta: {
					title: "Finding",
					//TODO: icon: 'tm:alert',
					tooltip: "View finding details",
					description: "View finding details",
					permissions: ["alert:read"],
				}
			},
			{
		path: "/asset/detail/:assetId(\\d+)/package/:packageId(\\d+)",
		component: () => import("src/pages/asset/AssetPackageDetailPage.vue"),
		meta: {
			title: "Package Remediation",
			icon: 'tm:package',
			description: "View application package remediation details and resolved CVEs.",
			permissions: ["remediate:read"],
			links: [
				{ to: '/remediation' },
			],
		}
			},
		{
			path: "/remediation",
			component: () => import("src/pages/asset/PatchPage.vue"),
			meta: {
				title: "Guided Remediation",
				icon: 'tm:patch',
				tooltip: "Risk-prioritized vulnerability remediation across all assets",
				description: "What ThreatMate can patch, what it patched and what failed — ranked by real-world risk.",
				permissions: ["remediate:read"],
			links: [
				{ to: '/device' },
				{ to: '/settings/auto-remediation' },
			],
			}
		},
		{
			path: "/kev",
			component: () => import("src/pages/vulnerability/KevPage.vue"),
			meta: {
				title: "Known Exploited Vulnerabilities",
				icon: 'local_fire_department',
				tooltip: "CVEs confirmed exploited in the wild, and the assets, applications, and OS they affect",
				description: "Dedicated dashboard for Known Exploited Vulnerabilities — CISA KEV and threat-intel (VulnCheck) KEV — with per-CVE affected asset, application, and OS drill-down.",
				permissions: ["vulnerability:read"],
				links: [
					{ to: '/remediation' },
				],
			}
		},
		{
		path: "/asset/detail/:assetId(\\d+)/remediation/:packageId",
		component: () => import("src/pages/remediation/RemediationResultPage.vue"),
		meta: {
			title: "Remediation Result",
			permissions: ["remediate:read"],
			links: [
				{ to: '/remediation' },
			],
		}
		},
			{
				path: "/alerts",
				component: () => import("src/pages/alert/FindingsPage.vue"),
				meta: {
					title: "Findings",
					icon: 'tm:alert',
					tooltip: "View security findings and notifications",
					description: "View all exposures for this tenant. You can sort and filter by category, severity, and more.",
					permissions: ["alert:read"],
					links: [
						{ to: '/missionplan' },
					],
				}
			},
			{
				path: "/alerts/cve/:cveId",
				component: () => import("src/pages/alert/ViewCvePage.vue"),
				meta: {
					title: "Vulnerability Details",
					links: [
						{ icon: 'tm:external-link', label: `NVD Information`, href: 'https://nvd.nist.gov/vuln/detail/:cveId' },
					],
				}
			},
			{
				path: "/lifecycle/asset/:assetId",
				component: () => import("src/pages/lifecycle/LifecycleAssetPage.vue"),
				meta: {
					title: "End-of-Life Lifecycle",
					icon: 'tm:lifecycle',
					permissions: ["asset:read"],
				}
			},
			{
				path: "/missionplan/:subsystem",
				component: () => import("src/pages/alertmissionplan/AlertMissionPlanPage.vue"),
				meta: {
					title: "{subsystem}",
					icon: 'tm:mission-plan',
				}
			},
			{
				path: "/missionplan/:subsystem/:subsystemFilter",
				component: () => import("src/pages/alertmissionplan/AlertMissionPlanPage.vue"),
				meta: {
					title: "{subsystemFilter}",
					icon: 'tm:mission-plan',
				}
			},
			{
				path: "/asset/detail/:assetId",
				component: () => import("src/pages/asset/AssetDetailPage.vue"),
				meta: {
					title: "{assetName}",
					icon: 'tm:detail',
					description: "This page shows detailed information about the asset.",
				}
			},
			{
				path: "/asset/detail/:assetId/port/:assetPortId",
				component: () => import("src/pages/asset/AssetPortDetailPage.vue"),
				meta: {
					title: "Port", // This will be overridden by the page.
					description: "This page shows detailed information about the asset port.",
				}
			},
			{
				path: "/device",
				component: () => import("src/pages/asset/DevicesPage.vue"),
				meta: {
					title: "Devices & Agents",
					icon: 'tm:device',
					tooltip: "View your device assets and endpoint agents",
					permissions: ["asset:read", "agent:read"],
					description: "The Devices & Agents page lists all discovered internal and external devices ordered by their maximum severity and all deployed agents.",
					links: [
						{ to: '/help/agent-install' },
						{ to: '/agent-hardware' },
					]
				}
			},
			{
				path: "/shadow-ai",
				component: () => import("src/pages/shadowai/ShadowAIPage.vue"),
				meta: {
					title: "Shadow AI",
					icon: "mdi-robot-outline",
					tooltip: "Discover AI and SaaS usage across your fleet",
					// Armour-tier, granted to every tenant during the free-access
					// window; a Shield tenant loses it when the window closes.
					permissions: ["shadow-ai:read"],
					feature: "shadow-ai",
					isNew: true,
					description: "Shadow AI Discovery: the AI tools in use across your fleet — installed, in-browser, and OAuth-granted — how heavily, on which accounts, and which devices and users are on the unsanctioned ones.",
					search: ["shadow ai", "ai", "ai governance", "ai tools", "ai usage"].join(" "),
				}
			},
			{
				// The former SaaS Users page is folded into Cloud
				// Identity.  Redirect keeps deep links working
				// (dashboard panels use ?platform= and ?tag=), so the
				// query must ride along.
				path: "/asset/user-summary",
				redirect: (to) => ({ path: "/integration/saas", query: to.query }),
			},
			{
				path: "/asset/detail/:assetId/missionplan",
				component: () => import("src/pages/asset/AssetMissionPlanPage.vue"),
				meta: {
					title: "Mission Plan",
					icon: 'tm:mission-plan',
					description: "The Mission Plan provides a prioritized list of actions to take to address the most critical threats.",
				}
			},
			{
				path: "/asset/detail/:assetId/missionplan/:subsystem",
				component: () => import("src/pages/asset/AssetMissionPlanPage.vue"),
				meta: {
					title: "{subsystem}",
					icon: 'tm:mission-plan',
					description: "The Mission Plan provides a prioritized list of actions to take to address the most critical threats.",
				}
			},
			{
				// TODO: Move this to something that makes sense
				path: "/assetporttlscert/detail/:assetPortCertId",
				component: () => import("src/pages/asset/AssetPortCertDetailPage.vue"),
				name: "AssetPortCertDetailPage",
			},
			{
				path: "/auditlog",
				component: () => import("src/pages/auditlog/AuditLogPage.vue"),
				meta: {
					title: "Audit Logs",
					icon: 'tm:health',
					permissions: ["auditlog:read"],
					description: "View audit logs.",
					beta: true,
				}
			},
			{
				path: "/billing/assets",
				component: () => import("src/pages/billing/BillingAssetsPage.vue"),
				meta: {
					title: "Billing & Usage",
					icon: 'tm:billing',
					permissions: ["billing:read"],
					description: "Billable assets include all assets that the ThreatMate platform is monitoring continuously. This includes cloud users and internal and external hosts monitored by ThreatMate.",
				}
			},
			{
				path: "/billing/thank-you",
				component: () => import("src/pages/billing/ThankYouPage.vue"),
				meta: {
					title: "Thanks for subscribing",
					icon: 'tm:billing',
				}
			},
			{
				path: "/integration/msp/autotask",
				component: () => import("src/pages/integration/autotask/DetailsPage.vue"),
				meta: {
					title: "Manage Autotask Integrations",
					permissions: ["cloud-account:read"],
				}
			},
			{
				// Constrain :id to digits so /integration/msp/autotask/foo
				// fails route matching instead of resolving with NaN as
				// integrationId. Matches the convention used elsewhere in
				// this file (e.g. the /asset/:id(\\d+) routes).
				path: "/integration/msp/autotask/:id(\\d+)",
				component: () => import("src/pages/integration/autotask/IntegrationPage.vue"),
				props: route => ({ integrationId: Number(route.params.id) }),
				meta: {
					title: "Autotask Integration",
					permissions: ["cloud-account:read"],
				}
			},
			{
				path: "/integration/msp/connectwise",
				component: () => import("src/pages/integration/connectwise/DetailsPage.vue"),
				meta: {
					title: "Manage ConnectWise Integrations",
					description: "Manage ConnectWise Integrations for this tenant.",
					permissions: ["cloud-account:read"],
				}
			},
			{
				path: "/integration/msp/connectwise/:id(\\d+)",
				component: () => import("src/pages/integration/connectwise/IntegrationPage.vue"),
				props: route => ({ integrationId: Number(route.params.id) }),
				meta: {
					title: "ConnectWise Integration",
					permissions: ["cloud-account:read"],
				}
			},
			{
				path: "/integration/msp/dattormm",
				component: () => import("src/pages/integration/dattormm/DetailsPage.vue"),
				meta: {
					title: "Manage Datto RMM Integrations",
					icon: 'tm:msp-integration',
					description: "Manage Datto RMM Integrations for this tenant.",
					permissions: ["cloud-account:read"],
				}
			},
			{
				// Constrain :id to digits — universal-framework routes are
				// keyed by asset id (the integration record's owning
				// asset), so a non-numeric path should fail to match
				// rather than try to resolve as a NaN assetId prop.
				path: "/integration/msp/dattormm/:id(\\d+)",
				component: () => import("src/pages/integration/dattormm/IntegrationPage.vue"),
				props: route => ({ assetId: Number(route.params.id) }),
				meta: {
					title: "Datto RMM Integration",
					icon: 'tm:msp-integration',
					permissions: ["cloud-account:read"],
				}
			},
			{
				path: "/integration/msp/ninjaone",
				component: () => import("src/pages/integration/ninjaone/DetailsPage.vue"),
				meta: {
					title: "Manage NinjaOne RMM Integrations",
					icon: 'tm:msp-integration',
					description: "Manage NinjaOne RMM Integrations for this tenant.",
					permissions: ["cloud-account:read"],
				}
			},
			{
				// Constrain :id to digits — universal-framework routes are
				// keyed by asset id (the integration record's owning
				// asset), so a non-numeric path should fail to match
				// rather than try to resolve as a NaN assetId prop.
				path: "/integration/msp/ninjaone/:id(\\d+)",
				component: () => import("src/pages/integration/ninjaone/IntegrationPage.vue"),
				props: route => ({ assetId: Number(route.params.id) }),
				meta: {
					title: "NinjaOne RMM Integration",
					icon: 'tm:msp-integration',
					permissions: ["cloud-account:read"],
				}
			},
			{
				path: "/integration/msp/ncentral",
				component: () => import("src/pages/integration/ncentral/DetailsPage.vue"),
				meta: {
					title: "Manage N-central Integrations",
					icon: 'tm:msp-integration',
					description: "Manage N-central Integrations for this tenant.",
					permissions: ["cloud-account:read"],
				}
			},
			{
				// Same digit-only constraint as the Datto route; assetId
				// must parse cleanly or the route should fail to match.
				path: "/integration/msp/ncentral/:id(\\d+)",
				component: () => import("src/pages/integration/ncentral/IntegrationPage.vue"),
				props: route => ({ assetId: Number(route.params.id) }),
				meta: {
					title: "N-central Integration",
					icon: 'tm:msp-integration',
					permissions: ["cloud-account:read"],
				}
			},
			{
				path: "/integration/msp/halo",
				component: () => import("src/pages/integration/halo/HaloDetailsPage.vue"),
				meta: {
					title: "Manage Halo Integrations",
					icon: 'tm:msp-integration',
					description: "Manage Halo Integrations for this tenant.",
					permissions: ["cloud-account:read"],
				}
			},
			{
				path: "/integration/msp/halo/:id(\\d+)",
				component: () => import("src/pages/integration/halo/IntegrationPage.vue"),
				props: route => ({ integrationId: Number(route.params.id) }),
				meta: {
					title: "Halo Integration",
					icon: 'tm:msp-integration',
					permissions: ["cloud-account:read"],
				}
			},
			{
				path: "/customer-management",
				component: () => import("pages/customer-management/CustomerManagementLandingPage.vue"),
				meta: {
					title: "Customer Management",
					permissions: ["customer-license:create"],
				}
			},
			{
				// Editing moved into a dialog over the console. The row is
				// reachable from there, so send old links to the list rather
				// than keeping a second, diverging edit form alive.
				path: "/customer-management/:customerId/edit-license/:licenseId",
				redirect: "/customer-management/licenses",
			},
			{
				path: "/customer-management/licenses",
				component: () => import("src/pages/customer-management/LicenseConsolePage.vue"),
				meta: {
					title: "Licenses",
					permissions: ["customer-license:create"],
					search: "license licenses trial trials tier shield armour expiring past due suspended",
				}
			},
			{
				// The console replaced the customer-picker page. Redirect rather
				// than delete so existing bookmarks and links keep working.
				path: "/customer-management/license-details",
				redirect: "/customer-management/licenses",
			},
			{
				path: "/customer-management/new-customer",
				component: () => import("pages/customer-management/NewCustomerPage.vue"),
				meta: {
					title: "New Customer",
					permissions: ["customer-license:create"],
				}
			},
			{
				// Creating a license moved into the console's dialog, which picks
				// the tenant itself. Old links land on the list.
				path: "/customer-management/:customerId/new-license",
				redirect: "/customer-management/licenses",
			},
			{
				path: "/dashboard/overview",
				component: () => import("pages/dashboard/Overview.vue"),
				meta: {
					title: "Overview",
					icon: 'tm:dashboard',
				}
			},
			{
			path: "/dashboard/overview-v2",
			component: () => import("pages/dashboard/ManagedTenantsPage.vue"),
			meta: {
				title: "Deployment Overview",
				icon: 'tm:dashboard',
			}
			},
			{
				path: "/missionplan",
				component: () => import("src/pages/alertmissionplan/MissionPlanV2Page.vue"),
				meta: {
					title: "Mission Plan",
					icon: 'tm:expanded-mission-plan',
					tooltip: "Every fix across your tenants, worst first",
					permissions: ["mission-plan:read"],
					description: "Every fix across your tenants in one list, worst first — open one to work it and patch from here.",
				}
			},
			{
				// The address the Mission Plan had while it was in preview.
				path: "/missionplan-v2",
				redirect: to => ({ path: "/missionplan", query: to.query }),
			},
			{
				path: "/prospecting",
				component: () => import("src/pages/prospecting/ProspectingWorkspacePage.vue"),
				meta: {
					title: "Prospecting",
					icon: 'tm:search',
					tooltip: "Discover and assess candidate businesses",
					permissions: ["prospect:read"],
					description: "Find candidate businesses by location and business type, then run a non-intrusive external assessment to produce a sales-ready risk report.",
				}
			},
			{
				// Matches only /prospecting/report/sample. Written as a
				// constrained param so universal search, which skips
				// parameterized routes, does not list the sample brief
				// beside real pages.
				path: "/prospecting/report/:sample(sample)",
				component: () => import("src/pages/prospecting/ExternalRiskBriefPage.vue"),
				meta: {
					title: "Sample External Risk Brief",
					permissions: ["prospect:read"],
					sampleReport: true,
				}
			},
			{
				path: "/prospecting/report/:reportId(\\d+)",
				component: () => import("src/pages/prospecting/ExternalRiskBriefPage.vue"),
				meta: {
					title: "External Risk Brief",
					permissions: ["prospect:read"],
				}
			},
			{
				// Page is a wizard and doesn't use tm-page
				path: "/integration/connectwise/wizard",
				component: () => import("src/pages/integration/connectwise/IntegrationWizard.vue"),
				meta: {
					title: "ConnectWise Integration Wizard",
				}
			},
			{
				// Page is a wizard and doesn't use tm-page
				path: "/integration/connectwise/company-preferences-wizard/:companyId",
				name: "CompanyPreferencesWizard",
				component: () => import("src/pages/integration/connectwise/CompanyPreferencesWizard.vue")
			},
			{
				// The Breach Exposure Report: accounts found in known breaches and
				// pastes. It reads /v1/darkweb/* only, so it needs
				// dark-web:read and no Deep Dark Web license; the report
				// below is the one that does.
				path: "/report/breach-exposure",
				component: () => import("pages/report/BreachExposureReportPage.vue"),
				name: 'BreachExposureReportPage',
				meta: {
					title: "Breach Exposure Report",
					icon: 'tm:dark-web-accounts',
					description: "Print-ready report of the accounts found in known breaches and public pastes: who to deal with first, the breaches behind the exposure, and the recommended actions.",
					tooltip: "Open the Breach Exposure Report",
					permissions: ["dark-web:read", "report:read"],
					search: ["dark web report", "breach report", "compromised accounts", "leaked passwords", "pastes"].join(" "),
					links: [
						{ to: "/darkweb/overview" },
						{ to: "/report/scheduled" },
						{ to: "/help/breach-exposure-report" },
					],
				}
			},
			{
				// Print-ready Deep Dark Web Report — modeled on the M365
				// report shape (cover + 4 content pages) with the
				// brand-themed dark palette baked into the SCSS. Uses
				// /v1/report/template?reportType=darkWeb so scheduled
				// PDF delivery works through the same code path as
				// the M365 wrapper.
				path: "/report/dark-web",
				component: () => import("pages/report/DarkWebReportPage.vue"),
				name: 'DarkWebReportPage',
				meta: {
					title: "Deep Dark Web Report",
					icon: 'tm:dark-web-report',
					description: "Print-ready report covering every Deep Dark Web exposure surfaced in the reporting window: infostealer logs, breach-feed credentials, leak-site mentions, and a tenant-tailored action plan.",
					tooltip: "Open the Deep Dark Web Report",
					permissions: ["dark-web:read", "report:read"],
					// Reachable at Shield (the permission is `dark-web:read`)
					// but every section worth printing reads the ARMOUR data
					// set, so the page renders the upgrade hero without it.
					// Badge the entry point rather than hide it — same rule
					// the Crown Jewels and Automated Remediation surfaces use.
					feature: "deep-dark-web",
					// Breach Library (`/darkweb/breach-summary`) is
					// reachable from inside Dark Web Overview, which also
					// carries the Affected accounts section, so we
					// intentionally don't surface it as a header action
					// here too.
					links: [
						{ to: "/darkweb/overview" },
						{ to: "/deepdarkweb" },
					],
				}
			},
			{
				// Live operational dashboard for analysts: KPI tiles,
				// risk callouts, charts, top breaches, and an affected-
				// accounts table.
				// This page used to live at /report/dark-web; it moved
				// here when the new printable report became the
				// canonical /report/dark-web entry.
				path: "/darkweb/overview",
				component: () => import("pages/darkweb/DarkWebOverviewPage.vue"),
				name: 'DarkWebOverviewPage',
				meta: {
					// Title says "Dark Web Overview" (not "Deep Dark
					// Web Overview") because this dashboard is the
					// Shield-tier baseline view — Affected Accounts +
					// Breach Library + the cross-signal risk callouts
					// all render without ARMOUR. The BreachSense /
					// Deep Dark Web findings panel inside the page is
					// gated to ARMOUR separately, so the page itself
					// shouldn't read as ARMOUR-only.
					title: "Dark Web Overview",
					icon: 'tm:dark-web-overview',
					description: "Unified live dashboard of accounts and credentials exposed in known breaches, with cross-signal risk callouts.",
					tooltip: "Open the Dark Web Overview dashboard",
					permissions: ["dark-web:read"],
					// Breach Library (`/darkweb/breach-summary`) is
					// reachable from this page's own Breach Library
					// section, and affected accounts are a section of
					// this page rather than a separate destination, so
					// neither needs to ride along as a header action.
					// "Manage ..." rather than inheriting the target's "Personal
					// Emails" title, and the same label on all three pages that
					// link here. A bare "Personal Emails" in a page header sits
					// beside actions that filter or scope the page you are already
					// on, so it reads as one of those rather than as a way out to
					// another page — most sharply on Cloud Identity, where the page
					// IS a list of email addresses.
					links: [
						{ to: "/darkweb/personal-emails", label: "Manage Personal Emails", permissions: ["dark-web:read"] },
						{ to: "/report/breach-exposure", permissions: ["report:read", "dark-web:read"] },
						{ to: "/report/dark-web" },
						{ to: "/alerts?subsystem=darkweb" },
					],
				}
			},
			{
				// Management surface for the Personal Emails watchlist:
				// addresses outside the tenant's directory that the customer
				// asked us to watch. Gated on dark-web:read (NOT
				// deep-dark-web) because the addresses are covered by the
				// breach-catalog sweep on every tier; only the Scan Now action
				// inside the page is Armour-gated, and the table hides it
				// per-permission.
				path: "/darkweb/personal-emails",
				component: () => import("pages/darkweb/PersonalEmailPage.vue"),
				name: 'PersonalEmailPage',
				meta: {
					title: "Personal Emails",
					icon: 'mdi-email-search-outline',
					description: "Addresses outside your directory that ThreatMate watches for breaches - an owner's personal address, a board member, a contractor. Each one counts as a billable user.",
					tooltip: "Manage the addresses ThreatMate watches for this tenant",
					permissions: ["dark-web:read"],
					// No /help/personal-emails here: the page's own help
					// section already links it, and a header action for the
					// help page you are being helped about is noise.
					links: [
						{ to: "/darkweb/overview" },
					],
				}
			},
			{
				path: "/darkweb/breach/:segmentId(\\d+)/:email",
				component: () => import("pages/darkweb/DarkWebBreachPage.vue"),
				name: 'DarkWebBreachPage',
				props: true,
				meta: {
					title: "Breaches",
				}
			},
			{
				path: "/darkweb/breach/details/:breachId",
				component: () => import("pages/darkweb/DarkWebBreachDetailsPage.vue"),
				name: 'DarkWebBreachDetailsPage',
				props: true,
				meta: {
					title: "Breach Details",
				}
			},
			{
				path: "/darkweb/breach-summary",
				component: () => import("pages/darkweb/DarkWebBreachSummaryPage.vue"),
				name: 'DarkWebBreachSummaryPage',
				meta: {
					title: "Breach Library",
					icon: 'tm:dark-web-breaches',
					description: "View all breaches found on the Deep Dark Web and a summary of their findings.",
					tooltip: "View Deep Dark Web Breaches",
					permissions: ["dark-web:read"],
				},
			},
			// Affected Accounts used to be its own page here. The Dark Web
			// Overview dashboard (#1192) grew an Affected accounts section
			// reading the same /v1/darkweb/summary, so the two drifted --
			// the same row-key bug had to be fixed twice, and the paste
			// column landed on one and not the other. The dashboard section
			// is now the only implementation. No production notification
			// rule and no rendered notification text referenced this path
			// (checked 2026-09-16), so nothing regenerates the link; the
			// redirect is for bookmarks and any ticket already in the wild.
			{ path: "/darkweb", redirect: "/darkweb/overview" },
			{
				// Deep Dark Web live dashboard.
				// /report/dark-web is the print-ready Deep Dark Web
				// Report; /darkweb/overview is the cross-signal triage
				// dashboard; this is the live insights view tenants
				// with the deep-dark-web license land on. Permission is
				// the standard `deep-dark-web:read`; the page renders a
				// calm upsell banner when the backend returns 403.
				path: "/deepdarkweb",
				component: () => import("pages/deepdarkweb/DeepDarkWebDashboardPage.vue"),
				name: "DeepDarkWebDashboardPage",
				meta: {
					title: "Deep Dark Web Insights",
					icon: "tm:dark-web-insights",
					description: "Live Deep Dark Web dashboard: severity-tiered counts, top affected domains/emails, recent findings, and per-finding reveal-secret access.",
					tooltip: "Open the Deep Dark Web Insights dashboard",
					permissions: ["deep-dark-web:read"],
					feature: "deep-dark-web",
					// Breach Library (`/darkweb/breach-summary`) is
					// reachable from inside Dark Web Overview, so we
					// don't surface it as a header action here too.
					// Personal Emails IS surfaced: the addresses it
					// manages are the ones whose findings show up here,
					// and it is otherwise only reachable from Dark Web
					// Overview.
					links: [
						{ to: "/darkweb/personal-emails", label: "Manage Personal Emails", permissions: ["dark-web:read"] },
						{ to: "/darkweb/overview" },
						{ to: "/report/dark-web" },
					],
				},
			},
			{
				// Per-finding detail page. Reached via row-clicks
				// from the dashboard's findings list and from the top-
				// affected drill-down lists. Hosts the reveal-secret
				// action against the audit-logged endpoint.
				path: "/deepdarkweb/finding/:id(\\d+)",
				component: () => import("pages/deepdarkweb/DeepDarkWebFindingPage.vue"),
				name: "DeepDarkWebFindingPage",
				props: true,
				meta: {
					title: "Deep Dark Web Finding",
					icon: "tm:dark-web-insights",
					permissions: ["deep-dark-web:read"],
					feature: "deep-dark-web",
				},
			},
			{ path: "/deepdarkweb/pivot/:assetEmailId(\\d+)", redirect: "/deepdarkweb" },
			// Backward-compat redirects from the old /darkwebenhanced/*
			// URLs onto the renamed /deepdarkweb/* twins. Bookmarks,
			// notification deep-links, and any older UI / agent caller
			// keep working until everyone has migrated to the new path.
			{ path: "/darkwebenhanced", redirect: "/deepdarkweb" },
			{ path: "/darkwebenhanced/finding/:id(\\d+)", redirect: to => "/deepdarkweb/finding/" + to.params.id },
			{ path: "/darkwebenhanced/pivot/:assetEmailId(\\d+)", redirect: "/deepdarkweb" },
			{
				path: "/discovery/dashboard",
				component: () => import("pages/discovery/DashboardPage.vue"),
				meta: {
					title: "Discovery Dashboard",
					deprecated: true,
				}
			},
			{
				path: "/discovery/health",
				component: () => import("pages/agent/DiscoveryHealthPage.vue"),
				meta: {
					title: "Discovery Health",
					icon: 'tm:health',
					tooltip: "Shows the last seen time for each scan group's discovery",
					description: "ThreatMate support may ask you for the information on this page. Please follow any instructions you receive.",
					permissions: ["discovery:read"],
				}
			},
			{
				path: "/dmarc/report",
				component: () => import("src/pages/dmarc/DmarcReportPage.vue"),
				meta: {
					title: "DMARC Activity",
					icon: "tm:domain",
					description: "Configure DMARC monitoring.",
					links: [
						{ to: '/report/domain-security' },
						{ to: '/report/dmarc-summary' },
					],
				}
			},
			{
				path: "/external-scan",
				component: () => import("src/pages/external-scan/ExternalScanPage.vue"),
				meta: {
					title: "Domains & IPs",
					icon: 'tm:external-scan',
					tooltip: "Manage external domains and IPs that ThreatMate will monitor for exposures",
					description: "Manage external domains & IPs.",
					permissions: ["domain:read", "externalip:read"],
					links: [
						{ to: 'report/domain-security' },
						{ to: 'dmarc/report' },
					]
				}
			},
			{
				path: "/external-scan/cidr/:externalcidrId(\\d+)",
				component: () => import("src/pages/external-scan/ExternalCIDRIPListPage.vue"),
				meta: {
					title: "{externalcidrName}",
					description: "Manage all external IPs for this CIDR.",
					links: [
					],
				}
			},
			{
				path: "/external-scan/domain/:domainId(\\d+)/subdomain",
				component: () => import("src/pages/external-scan/SubdomainListPage.vue"),
				meta: {
					title: "{domainName}",
					description: "Manage all subdomains for a domain.",
				}
			},
			{
				path: "/endpoint/dashboard",
				component: () => import("src/pages/endpoint/AgentDashboardPage.vue"),
				meta: {
					title: "Endpoints Dashboard",
					deprecated: true,
				}
			},
			{
				path: "/feedback",
				component: () => import("src/pages/SendFeedback.vue"),
				meta: {
					title: "Send Feedback",
					icon: 'tm:feedback',
					description: "Please send us your feedback.",
				}
			},
			{
				path: "/support",
				component: () => import("src/pages/SupportPage.vue"),
				meta: {
					title: "Contact Us",
					icon: 'tm:support',
					description: "Open a support ticket or reach the ThreatMate team.",
					tooltip: 'Open a support ticket or reach the ThreatMate team',
					permissions: ["support:read"],
				}
			},
			{
				path: "/help/support-tickets",
				component: () => import("src/pages/help/HelpSupportTicketsPage.vue"),
				meta: {
					title: "Support Tickets Guide",
					icon: 'tm:help',
					description: "Open, track, comment on, and close ThreatMate support tickets from inside the app.",
					// Gated, unlike the static-prose help routes: its Help card is
					// gated on support:read too, and every link on the page goes
					// to /support, which a reader without it cannot open.
					permissions: ["support:read"],
					links: [
						{ to: '/support' },
						{ to: '/feedback' },
					],
				}
			},
			{
				path: "/help",
				component: () => import("src/pages/help/HelpLandingPage.vue"),
				meta: {
					title: "Help",
					icon: 'tm:help',
					tooltip: 'Get general help with ThreatMate',
				}
			},
			{
				path: "/help/getting-started",
				component: () => import("src/pages/help/HelpMSPGettingStartedPage.vue"),
				meta: {
					title: "Getting Started",
					icon: 'tm:help',
					description: "Walkthrough for an MSP technician standing up ThreatMate: tenant tree, external scans, cloud scans, internal scans via the Universal Agent, Mission Plan triage, and deployment best practices.",
					links: [
						{ to: '/settings/tenant' },
						{ to: '/external-scan' },
						{ to: '/integration/saas' },
						{ to: '/device' },
						{ to: '/internal-scan/subnet' },
						{ to: '/missionplan' },
					],
				}
			},
			{
				path: "/help/agent-install",
				component: () => import("src/pages/help/HelpAgentInstallPage.vue"),
				meta: {
					title: "Agent Install Guide",
					icon: 'tm:help',
					description: "ThreatMate Agent is a software agent that can be installed on Windows, MacOS, and Linux systems to monitor and manage devices.",
					// The Antivirus & EDR exclusions section, which the title and
					// description do not mention. These are the words someone
					// reaches for when endpoint protection is blocking the agent.
					search: "antivirus edr endpoint protection exclusion sentinelone sentinel one trend micro worry-free allowlist whitelist quarantine",
				}
			},
			{
				path: "/help/agent-usage",
				component: () => import("src/pages/help/HelpAgentUsagePage.vue"),
				meta: {
					title: "Agent Usage Guide",
					icon: 'tm:help',
					// Deleting a device and keeping it out of discovery lives in
					// this guide.
					search: "delete device remove device keep device out stop monitoring ignore device rediscovered comes back exclude device",
					links: [
						{ to: '/help/agent-install' },
						{ to: '/help/agent-usage/advanced' },
						{ to: '/help/penetration-testing' },
					],
				}
			},
			{
				path: "/help/agent-usage/advanced",
				component: () => import("src/pages/help/HelpAgentAdvancedUsagePage.vue"),
				meta: {
					title: "Agent Advanced Usage Guide",
					icon: 'tm:help',
					links: [
						{ to: '/help/agent-usage' },
					],
				}
			},
			{
				path: "/help/mission-plan",
				component: () => import("src/pages/help/HelpMissionPlanPage.vue"),
				meta: {
					title: "Mission Plan",
					icon: 'tm:help',
					description: "How to work the plan: the fix list and Standing, patching a fix in place, what each device status means, tickets and keyboard shortcuts.",
					// No permission, matching the 32 other help routes that carry none.
					// HelpLandingPage shows this card to everyone (permissions: []), so a
					// gate here only sends the people who click it to /missing-permission
					// — and it gated on alert:read while the page it documents needs
					// mission-plan:read.
				}
			},
			{
				path: "/help/remediation",
				component: () => import("src/pages/help/HelpRemediationPage.vue"),
				meta: {
					title: "Guided Remediation",
					icon: 'tm:help',
					description: "Setup guide, configuration reference, and best practices for guided remediation.",
					permissions: ["remediate:read"],
					links: [
						{ to: '/remediation' },
					],
				}
			},
			{
				path: "/help/os-patches",
				component: () => import("src/pages/help/HelpOsPatchesPage.vue"),
				meta: {
					title: "Operating System Patches",
					icon: 'tm:help',
					description: "How ThreatMate identifies the Microsoft KB update that fixes each Windows OS CVE, shown on findings and on the device's asset page.",
				}
			},
			{
				path: "/help/kev",
				component: () => import("src/pages/help/HelpKevPage.vue"),
				meta: {
					title: "Known Exploited Vulnerabilities",
					icon: 'tm:help',
					description: "How the KEV dashboard surfaces CISA and threat-intel exploited CVEs and the assets, applications, and OS they affect.",
					permissions: ["vulnerability:read"],
					links: [
						{ to: '/kev' },
					],
				}
			},
			{
				path: "/help/purple-knight",
				component: () => import("src/pages/help/HelpPurpleKnightPage.vue"),
				meta: {
					title: "Active Directory Security",
					icon: 'tm:help',
					description: "How to import Purple Knight reports, read the AD security score, and drill into the accounts and objects behind each Indicator of Exposure.",
					permissions: ["purple-knight:read"],
					links: [
						{ to: '/purple-knight/report' },
					],
				}
			},
			{
				path: "/help/end-of-life",
				component: () => import("src/pages/help/HelpEndOfLifePage.vue"),
				meta: {
					title: "End-of-Life Detection",
					icon: 'tm:help',
					description: "How ThreatMate detects end-of-life operating systems and applications, what the statuses mean, and how to read the release timeline.",
					permissions: ["asset:read"],
					links: [
						{ to: '/alerts' },
					],
				}
			},
			{
				path: "/help/firmware-vulnerabilities",
				component: () => import("src/pages/help/HelpFirmwareVulnerabilitiesPage.vue"),
				meta: {
					title: "Firmware Vulnerabilities",
					icon: 'tm:help',
					description: "How ThreatMate detects vulnerable BIOS/UEFI firmware, which machines are covered, and how to update.",
					// No permission, matching the 29 other help routes that carry
					// none. The page is static prose and reads no asset data, and
					// its landing card is unfiltered like every other one — with
					// asset:read here, a user without it who clicks the card lands
					// on /missing-permission rather than on the article.
					links: [
						{ to: '/alerts' },
					],
				}
			},
			{
				path: "/help/software-finding-sources",
				component: () => import("src/pages/help/HelpSoftwareFindingSourcesPage.vue"),
				meta: {
					title: "Software Finding Sources",
					icon: 'tm:help',
					description: "Where the software named in a vulnerability finding came from, what the Source and Path chips mean, and why a network-observed finding is not an install.",
					// No permission, matching the other help routes: static prose
					// that reads no asset data, reached from an unfiltered landing
					// card.
					// Only terms the title and description do not already cover.
					search: "not applicable client-side openssh ssh scp sftp ssh-agent banner",
					links: [
						{ to: '/alerts' },
					],
				}
			},
			{
				path: "/help/findings",
				component: () => import("src/pages/help/HelpFindingsPage.vue"),
				meta: {
					title: "Findings",
					icon: 'tm:help',
					description: "Choosing the Findings table's columns, CVE, CVSS and EPSS, sorting, searching and CSV export; when a finding closes or ages out, what happens when a device stops reporting or comes back, which source wins, how long devices and findings are kept, and the settings that change it.",
					// No permission, matching the other help routes: static prose
					// that reads no data, reached from an unfiltered landing card.
					// Only terms the title and description do not already cover.
					search: "retention expire expired alert aged out not seen no visibility issue no longer detected not applicable asset deleted closed findings stale offline not checking in agent returns last seen deleted device scan result freshness data retention local authenticated scan max age",
					links: [
						{ to: '/alerts' },
					],
				}
			},
			{
				path: "/help/billable-assets",
				component: () => import("src/pages/help/HelpBillableAssetsPage.vue"),
				meta: {
					title: "Billable Assets",
					icon: 'tm:help',
					description: "What counts as a billable asset, how the hourly snapshots are measured, and how to reconcile the report with your invoice.",
					permissions: ["billing:read"],
					links: [
						{ to: '/billing/assets' },
					],
				}
			},
			{
				path: "/config-hardening",
				component: () => import("src/pages/hardening/ConfigHardeningFleetPage.vue"),
				name: 'ConfigHardeningFleetPage',
				meta: {
					title: "Config Hardening",
					icon: 'tm:config-hardening',
					description: "Environment-wide view of endpoint security hardening: tenant score and trend, which controls fail on how many devices, acknowledgments with audit-grade justifications, and the evidence CSV export.",
					tooltip: "Open the Config Hardening overview",
					permissions: ["endpoint-hardening:read"],
					// See the note on /pii/dashboard; FEATURE_ENDPOINT_HARDENING.
					feature: "endpoint-hardening",
					// The help article shares this page's title: labelled, or the
					// header shows the same name twice.
					links: [
						{ label: 'Help', to: '/help/config-hardening' },
					],
				}
			},
			{
				path: "/settings/configuration-profiles",
				component: () => import("src/pages/hardening/ConfigurationProfilesPage.vue"),
				name: 'ConfigurationProfilesPage',
				meta: {
					title: "Configuration Profiles",
					icon: 'tm:configuration-profiles',
					description: "What each tenant is checked on, and which failing settings create findings.",
					tooltip: "Open Configuration Profiles",
					// Shield and up, for Microsoft 365; the page leaves the
					// Windows half out without Armour.
					permissions: ["configuration-profile:read"],
					beta: true,
					isNew: true,
					// Only terms the title and description do not already cover.
					search: "windows microsoft config hardening profile assign inherit report only create finding don't check ignore baseline standard cis benchmark compliance hipaa soc 2 pci nist iso cyber insurance m365 office 365 scubagear cisa secure score entra exchange defender teams sharepoint",
					// The help article shares the dashboard's title, so it is
					// labelled here or the header shows the same name twice.
					links: [
						{ to: '/config-hardening' },
						{ label: 'Help', to: '/help/config-hardening' },
					],
				}
			},
			{
				path: "/settings/configuration-profiles/new",
				component: () => import("src/pages/hardening/ConfigurationProfileEditorPage.vue"),
				meta: {
					title: "New Profile",
					icon: 'tm:configuration-profiles',
					permissions: ["configuration-profile:read", "configuration-profile:write", "segment:update"],
					beta: true,
				}
			},
			{
				path: "/settings/configuration-profiles/edit/:id(\\d+)",
				component: () => import("src/pages/hardening/ConfigurationProfileEditorPage.vue"),
				meta: {
					title: "Profile",
					icon: 'tm:configuration-profiles',
					permissions: ["configuration-profile:read"],
					beta: true,
				}
			},
			{
				path: "/help/agent-collector-health",
				component: () => import("src/pages/help/HelpAgentCollectorHealthPage.vue"),
				meta: {
					title: "Agent Collector Health",
					icon: 'tm:help',
					description: "Why a device can show as online and still collect no security data, what the threatmate-osqueryd alerts mean, and how to fix and verify one.",
					// Only terms the title and description do not already cover:
					// useSearch matches those first, so repeating "osquery",
					// "collector" or "alert" here would buy nothing. These are the
					// words someone reaches for when they have the SYMPTOM and not
					// the cause — a finding that will not clear, an inventory that
					// stopped moving — which is how this page is actually found.
					search: "stale finding not clearing inventory stopped no data collected scan not running collector stopped last seen not updating",
				},
			},
			{
				path: "/help/config-hardening",
				component: () => import("src/pages/help/HelpConfigHardeningPage.vue"),
				meta: {
					title: "Config Hardening",
					icon: 'tm:help',
					description: "How ThreatMate scores a Windows endpoint's security settings against a hardening baseline, what passing/failing/inconclusive mean, and how to fix each control.",
					// Public help page (no permission gate), matching
					// /help/deep-dark-web and /help/pii-scanner: endpoint-hardening:read
					// is Armour-only, so gating the route bounced every Shield reader
					// to /missing-permission from an ungated landing card.
					// See the note on /pii/dashboard; FEATURE_ENDPOINT_HARDENING.
					// The pairing matters because this ungated page is exactly
					// where an unlicensed Shield reader lands, so it has to name
					// the plan.
					feature: "endpoint-hardening",
					links: [
						{ to: '/device' },
						{ to: '/config-hardening' },
					],
				}
			},
			{
				path: "/help/asset-tags",
				component: () => import("src/pages/help/HelpAssetTagsPage.vue"),
				meta: {
					title: "Device Tags",
					icon: 'tm:help',
					description: "Organize devices with tags: add and edit them on one device or many at once, and search the Devices & Agents grid by tag.",
					links: [
						{ to: '/device' },
					],
				}
			},
			{
				path: "/help/pii-scanner",
				component: () => import("src/pages/help/HelpPIIScannerPage.vue"),
				meta: {
					title: "Crown Jewels Detection Configuration",
					icon: 'tm:help',
					description: "Learn how to configure Crown Jewels Detection to identify sensitive data on endpoint devices.",
					// See the note on /pii/dashboard; FEATURE_CROWN_JEWELS.
					feature: "crown-jewels",
					links: [
						{ to: '/help/agent-usage' },
					],
				}
			},
			{
				path: "/help/notifications",
				component: () => import("src/pages/help/HelpNotificationsPage.vue"),
				meta: {
					title: "Notifications",
					icon: 'tm:help',
				}
			},
			{
				path: "/help/external-scan",
				component: () => import("src/pages/help/HelpExternalScanPage.vue"),
				meta: {
					title: "External scans and pentests",
					icon: 'tm:help',
					description: "How external discovery, port scans, SPF/DMARC checks, and penetration tests work and how to control them.",
					links: [
						{ to: '/external-scan' },
						{ to: '/report/domain-security' },
						{ to: '/pentest/summary' },
						{ to: '/help/pentest-evidence' },
					],
				}
			},
			{
				path: "/help/device-identification",
				component: () => import("src/pages/help/HelpDeviceIdentificationPage.vue"),
				meta: {
					title: "Device identification",
					icon: 'tm:help',
					description: "How ThreatMate works out what an unmanaged device is - type, manufacturer, model and OS - from what it already says on the network, and what the addresses on a device's identity line mean.",
					search: "device identification fingerprint device type manufacturer model os family unidentified appliance printer camera router firewall nas ups switch mac oui banner tls certificate realm unmanaged public ip local ip external address nat egress vpn network location correct override set device type manually wrong type edit",
					links: [
						{ to: '/device' },
						{ to: '/help/pentest-evidence' },
						{ to: '/help/asset-tags' },
					],
				}
			},
			{
				path: "/help/penetration-testing",
				component: () => import("src/pages/help/HelpPenetrationTestingPage.vue"),
				meta: {
					title: "Penetration testing",
					icon: 'tm:help',
					description: "What a penetration test does: the attack vectors it covers, the checks it runs and the ones it never runs, how a test executes, what it leaves behind, and the settings that shape it.",
					search: "penetration test pentest methodology attack vector attack types nuclei template check default credentials brute force fuzzing dast dom xss dns zone transfer out of band callback exclude template id rate limit concurrency deadline stall cleanup implant persistence soc mdr allowlist scanner header internal external agent",
					links: [
						{ to: '/pentest/summary' },
						{ to: '/help/pentest-evidence' },
					],
				}
			},
			{
				path: "/help/pentest-evidence",
				component: () => import("src/pages/help/HelpPentestEvidencePage.vue"),
				meta: {
					title: "Pentest evidence",
					icon: 'tm:help',
					description: "The proof captured alongside a penetration test finding: screenshots, the HTTP exchange, and the browserless fingerprint bundle.",
					links: [
						{ to: '/pentest/summary' },
						{ to: '/help/device-identification' },
						{ to: '/help/external-scan' },
						{ to: '/help/network-pentest-report' },
					],
				}
			},
			{
				path: "/help/breach-exposure-report",
				component: () => import("src/pages/help/HelpBreachExposureReportPage.vue"),
				meta: {
					title: "Breach Exposure Report",
					icon: 'tm:help',
					description: "How to read the Breach Exposure Report, what it counts as exposed, and how to schedule it for a tenant.",
					search: "dark web report breach paste compromised accounts leaked passwords privileged mfa acknowledged scheduled pdf",
					links: [
						{ to: '/report/breach-exposure' },
						{ to: '/darkweb/overview' },
						{ to: '/report/scheduled' },
						{ to: '/help/deep-dark-web' },
					],
				}
			},
			{
				path: "/help/dmarc-summary-report",
				component: () => import("src/pages/help/HelpDmarcSummaryReportPage.vue"),
				meta: {
					title: "DMARC Summary Report",
					icon: 'tm:help',
					description: "How to read the DMARC Summary Report, which days it covers, and how to schedule it for a tenant.",
					search: "dmarc summary report monthly email authentication spoofing verified senders protection level monitoring quarantine reject scheduled pdf",
					links: [
						{ to: '/report/dmarc-summary' },
						{ to: '/dmarc/report' },
						{ to: '/report/scheduled' },
						{ to: '/help/external-scan' },
					],
				}
			},
			{
				path: "/help/scheduled-reports",
				component: () => import("src/pages/help/HelpScheduledReportsPage.vue"),
				meta: {
					title: "Scheduled Reports Guide",
					icon: 'tm:help',
					description: "Schedule a report to arrive by email, choose its minimum severity, what happens when a report is too large to email, and how to get the complete report.",
					search: "scheduled report email schedule recipients pdf attachment minimum severity critical high filter smaller shortened truncated size limit too large complete report print pdf",
					links: [
						{ to: '/report/scheduled' },
						{ to: '/report' },
					],
				}
			},
			{
				path: "/help/network-pentest-report",
				component: () => import("src/pages/help/HelpNetworkPentestReportPage.vue"),
				meta: {
					title: "Network Penetration Test Report",
					icon: 'tm:help',
					description: "How to read the network penetration test report: scope and attack surface, what was tested and came back clean, the confirmed findings, and the reconnaissance record.",
					search: "pentest report network penetration test pdf assessment coverage hosts tested clean reconnaissance host identification fingerprint technology profile scope attack surface findings remediation",
					links: [
						{ to: '/report/network-pentest' },
						{ to: '/help/pentest-evidence' },
						{ to: '/help/external-scan' },
					],
				}
			},
			{
				path: "/help/endpoint-report",
				component: () => import("src/pages/help/HelpEndpointReportPage.vue"),
				meta: {
					title: "Endpoint Report",
					icon: 'tm:help',
					description: "How the endpoint report reads: the current view of the findings open today, a timeframe that lists every finding seen in a period with whether it is still open, and what the report leaves out.",
					search: "endpoint report current timeframe findings alerts open closed status agent devices minimum severity acknowledged deferred max alerts pdf scheduled",
					links: [
						{ to: '/report/endpoint' },
						{ to: '/report/scheduled' },
						{ to: '/help/scheduled-reports' },
					],
				}
			},
			{
				path: "/help/network-vulnerability-report",
				component: () => import("src/pages/help/HelpNetworkVulnerabilityReportPage.vue"),
				meta: {
					title: "Network Vulnerability Report",
					icon: 'tm:help',
					description: "How the network vulnerability report reads: the current view that matches the asset page, a timeframe that shows what the scans in a period found, which devices it lists, and what a device's page shows.",
					search: "network vulnerability report current timeframe asset inventory open ports ports hosts devices names interfaces mac addresses cves tls certificates ciphers scan group pdf scheduled agent rmm",
					links: [
						{ to: '/report/network-vulnerability' },
						{ to: '/report/scheduled' },
						{ to: '/help/scheduled-reports' },
					],
				}
			},
			{
				// Public help page (no permission gate) explaining the Deep
				// Dark Web feature, its scan schedules, and how to read the
				// Deep Dark Web report. Customers on any tier can land here;
				// the dashboard / report pages remain Armour-gated, but
				// understanding what the feature does shouldn't be paywalled.
				path: "/help/deep-dark-web",
				component: () => import("src/pages/help/HelpDeepDarkWebPage.vue"),
				meta: {
					title: "Deep Dark Web",
					icon: 'tm:help',
					description: "How Deep Dark Web monitoring works, when scans run, what data is collected, and how to read the Deep Dark Web report.",
					// See the note on /pii/dashboard; FEATURE_DARK_WEB_ENHANCED.
					// The help landing card badges this article, so the page
					// header has to badge it too.
					feature: "deep-dark-web",
					links: [
						{ to: '/deepdarkweb' },
						{ to: '/report/dark-web' },
						{ to: '/darkweb/overview' },
					],
				}
			},
			{
				path: "/help/shadow-ai",
				component: () => import("src/pages/help/HelpShadowAIPage.vue"),
				meta: {
					title: "Shadow AI Discovery",
					icon: 'tm:help',
					description: "What Shadow AI Discovery finds, how the three signals work, turning on the browser sensor, sanction tiers, and what we collect.",
					isNew: true,
					search: ["shadow ai", "ai", "browser sensor", "ai governance", "ai risk"].join(" "),
					links: [
						{ to: '/shadow-ai' },
						{ to: '/report/ai-risk' },
					],
				}
			},
			{
				// Public help page (no permission gate, no feature badge):
				// personal emails are checked against the breach catalog on
				// every plan, and only the Deep Dark Web "Scan Now" action on
				// them is Armour-gated. The page's main job is explaining that
				// each address counts as a billable user, which every tier
				// needs to understand before adding any.
				path: "/help/personal-emails",
				component: () => import("src/pages/help/HelpPersonalEmailsPage.vue"),
				meta: {
					title: "Personal Emails",
					icon: 'tm:help',
					description: "Monitoring addresses that aren't in your directory — an owner's personal address, a board member, a contractor — how to add them one at a time or in bulk, and how each one counts toward your billable users.",
					links: [
						{ to: '/darkweb/personal-emails' },
						{ to: '/darkweb/overview' },
						{ to: '/billing/assets' },
					],
				}
			},
			{
				path: "/help/prospecting",
				component: () => import("src/pages/help/HelpProspectingPage.vue"),
				meta: {
					title: "Prospecting",
					icon: 'tm:help',
					description: "How to find candidate businesses, run non-intrusive external assessments, and use the results in your sales outreach.",
					links: [
						{ to: '/prospecting' },
					],
				}
			},
			{
				path: "/help/prospecting-score",
				component: () => import("src/pages/help/HelpProspectingScorePage.vue"),
				meta: {
					title: "Prospecting Score",
					icon: 'tm:help',
					description: "Learn how prospecting scores are calculated.",
					links: [
						{ to: '/report/prospect' },
					],
				}
			},
			{
				path: "/help/user-roles",
				component: () => import("src/pages/help/HelpUserRolesPage.vue"),
				meta: {
					title: "User Roles and Permissions",
					icon: 'tm:help',
					description: "Learn how to create and manage user roles and permissions.",
					links: [
						{ to: '/settings/userrole' },
					],
				}
			},
			{
				path: "/help/single-sign-on",
				component: () => import("src/pages/help/HelpSingleSignOnPage.vue"),
				meta: {
					title: "Single Sign-On",
					icon: 'tm:help',
					description: "Let your organization sign in with your own identity provider (Okta, Entra ID, Google Workspace).",
					links: [
						{ to: '/settings/sso' },
					],
				}
			},
			{
				path: "/help/microsoft-integration",
				component: () => import("src/pages/help/HelpMicrosoftIntegrationPage.vue"),
				meta: {
					title: "Microsoft 365 Integration",
					icon: 'tm:help',
					description: "Learn about the Microsoft 365 integration, required permissions, MFA analysis, ScubaGear assessments, and the permissions third-party apps hold.",
					search: "oauth saas apps authorized saas apps enterprise applications third-party apps consent scopes delegated permissions global permissions user permissions high-risk high risk scopes export users and scopes stale password stale user dormant inactive last login last sign-in password age 365 days one year",
					links: [
						{ to: '/integration/saas' },
					],
				}
			},
			{
				path: "/help/duo-integration",
				component: () => import("src/pages/help/HelpDuoIntegrationPage.vue"),
				meta: {
					title: "Duo Security Integration",
					icon: 'tm:help',
					description: "Learn how to set up the Duo Security integration, required permissions, and sync configuration.",
					links: [
						{ to: '/integration/saas' },
					],
				}
			},
			{
				path: "/help/halo-integration",
				component: () => import("src/pages/help/HelpHaloIntegrationPage.vue"),
				meta: {
					title: "Halo PSA Integration",
					icon: 'tm:help',
					description: "Notification profile reference for the Halo PSA integration: per-field explanations, recommended Halo-side configuration, and best practices for ticket lifecycle.",
					links: [
						{ to: '/integration/msp/halo' },
					],
				}
			},
			{
				path: "/help/connectwise-integration",
				component: () => import("src/pages/help/HelpConnectWiseIntegrationPage.vue"),
				meta: {
					title: "ConnectWise PSA Integration",
					icon: 'tm:help',
					description: "ConnectWise PSA integration guide: set it up at your top-level tenant, map companies (and Sites) to tenants, and link notification profiles to rules.",
					links: [
						{ to: '/integration/msp/connectwise' },
					],
				}
			},
			{
				path: "/help/autotask-integration",
				component: () => import("src/pages/help/HelpAutotaskIntegrationPage.vue"),
				meta: {
					title: "Autotask PSA Integration",
					icon: 'tm:help',
					description: "Autotask PSA integration guide: set it up at your top-level tenant, map companies to tenants, and link notification profiles to rules.",
					links: [
						{ to: '/integration/msp/autotask' },
					],
				}
			},
			{
				path: "/help/ncentral-integration",
				component: () => import("src/pages/help/HelpNcentralIntegrationPage.vue"),
				meta: {
					title: "N-central Integration",
					icon: 'tm:help',
					description: "Agent-less vulnerability scanning via N-central: what it pulls, how to map customers, and where devices appear.",
					links: [
						{ to: '/integration/msp/ncentral' },
					],
				}
			},
			{
				path: "/help/dattormm-integration",
				component: () => import("src/pages/help/HelpDattoRmmIntegrationPage.vue"),
				meta: {
					title: "Datto RMM Integration",
					icon: 'tm:help',
					description: "Agent-less vulnerability scanning via Datto RMM: what it pulls, how to map sites, and where devices appear.",
					links: [
						{ to: '/integration/msp/dattormm' },
					],
				}
			},
			{
				path: "/help/ninjaone-integration",
				component: () => import("src/pages/help/HelpNinjaOneIntegrationPage.vue"),
				meta: {
					title: "NinjaOne Integration",
					icon: 'tm:help',
					description: "Agent-less vulnerability scanning via NinjaOne: what it pulls, how to map organizations, and where devices appear.",
					links: [
						{ to: '/integration/msp/ninjaone' },
					],
				}
			},
			{
				path: "/help/api",
				component: () => import("src/pages/help/HelpSwaggerApiPage.vue"),
				meta: {
					title: "REST API (OpenAPI / Swagger)",
					icon: 'tm:help',
					description: "Use the ThreatMate REST API, OpenAPI specification, authentication, and example curl calls.",
					links: [
						{ to: '/profile' },
					],
				}
			},
			{
				path: "/integration/saas",
				component: () => import("src/pages/integration/SaasAppLandingPage.vue"),
				meta: {
					title: "Cloud Identity",
					icon: 'tm:saas-app',
					tooltip: "Connect identity platforms and monitor your cloud users",
					description: "The Cloud Identity page lists your connected identity platforms (Microsoft 365, Google Workspace, Duo) and your cloud users with a summary of their exposures.",
					search: [
						"2fa",
						"cloud",
						"duo",
						"google",
						"identity",
						"integrate",
						"integration",
						"mfa",
						"microsoft",
						"saas",
						"users",
					].join(" "),
					permissions: ["cloud-account:read"],
					// On the label, see the note on the Dark Web Overview link; it
					// is the same on all three pages that link here.
					//
					// Permission-gated because this crosses a boundary the other
					// two links do not -- Cloud Identity is cloud-account:read and
					// the target is dark-web:read, so a role can hold one without
					// the other. TmActionsBar hides an action whose permissions the
					// caller lacks, which is better than a header button that
					// bounces them.
					links: [
						{ to: "/darkweb/personal-emails", label: "Manage Personal Emails", permissions: ["dark-web:read"] },
					],
				}
			},
			{
				path: "/integration/msp",
				component: () => import("src/pages/integration/MSPIntegrationLandingPage.vue"),
				meta: {
					title: "MSP Integrations",
					icon: 'tm:msp-integration',
					tooltip: "Setup MSP integrations",
					description: "Add MSP integrations to your tenant.",
					search: [
						"autotask",
						"connectwise",
						"controlmap",
						"halo",
						"n-able",
						"n-central",
						"nable",
						"ncentral",
						"ninjaone",
						"ninjarmm",
						"senteon",
						"vanta",
					].join(" "),
					permissions: ["cloud-account:read"],
					links: [
						{ to: '/settings/tenant' },
					],
				}
			},
			{
				path: "/integration/microsoft/:integrationId(\\d+)/control-details/:controlId(\\d+)",
				component: () => import("pages/integration/microsoft/MicrosoftControlDetailsPage.vue"),
				meta: {
					title: "Microsoft Score Control Details",
				}
			},
			{
				// SCuBA control IDs contain dots (e.g. MS.DEFENDER.1.1v1) which
				// Vite/Quasar's history fallback misreads as static-file
				// requests, so the control name rides in a query string
				// instead of the path.
				path: "/integration/microsoft/recommendation",
				component: () => import("pages/integration/microsoft/MicrosoftBaselineRecommendationPage.vue"),
				meta: {
					title: "Microsoft 365 Baseline Recommendation",
					permissions: ["remediate:read"],
				}
			},
			{
				path: "/internal-scan/subnet",
				component: () => import("src/pages/internal-scan/InternalSubnetListPage.vue"),
				meta: {
					title: "Internal Subnets",
					icon: 'tm:internal-scan',
					tooltip: "Manage internal subnets that ThreatMate will monitor for exposures",
					description: "This page displays the internal subnets found by any installed ThreatMate agents.",
					permissions: ["agent:read"],
					links: [
						{ to: '/device' },
					],
				}
			},
			{
				// /internal-scan has no route so breadcrumbs are not able to be generatead
				path: "/internal-scan/subnet/:id(\\d+)/exclude",
				component: () => import("src/pages/internal-scan/InternalSubnetExcludeListPage.vue"),
				name: 'InternalSubnetExcludeListPage',
				meta: {
					title: "Manage IP Exclusions",
					description: "This page lists the IP addresses that will be excluded when scanning this particular subnet. Any IP address listed here will not be scanned (as part of device discovery, vulnerability scanning, etc.).",
					permissions: ["agent:read"],
				}
			},
			{
				path: "/internal-scan/subnet/:id(\\d+)/portexclude",
				component: () => import("src/pages/internal-scan/InternalSubnetPortExcludeListPage.vue"),
				name: 'InternalSubnetPortExcludeListPage',
				meta: {
					title: "Manage Port Exclusions",
					description: "This page lists the ports that will be excluded when scanning this particular subnet. Any port listed here will not be probed during vulnerability scans for the matching hosts.",
					permissions: ["agent:read"],
				}
			},
			{
				path: "/missing-permission/:permission",
				component: () => import("pages/MissingPermissionPage.vue"),
				meta: {
					title: "Missing Permission",
					// TODO: icon: '',
				}
			},
			{
				path: "/notification",
				redirect: "/alerts?tab=notifications"
			},
			{
				// TODO: Allow getting of notification rule name
				path: "/settings/notificationrule/:id",
				component: () => import("pages/notificationrule/NotificationRuleEditorPage.vue"),
				meta: {
					title: "Edit Rule",
				}
			},
			{
				path: "/profile",
				component: () => import("src/pages/profile/ProfilePage.vue"),
				meta: {
					title: "Profile",
					icon: "tm:profile",
				},
			},
			// Legacy sub-pages — kept as redirects so existing bookmarks,
			// emails, and the sidebar nav don't 404. The unified profile page
			// is now the single destination for all of these.
			{
				path: "/profile/password",
				redirect: "/profile",
			},
			{
				path: "/profile/totp",
				redirect: "/profile",
			},
			{
				path: "/profile/user-api-key",
				redirect: "/profile",
			},
			{
				path: "/purple-knight/report",
				component: () => import("src/pages/purple-knight/PurpleKnightDashboardPage.vue"),
				meta: {
					title: "AD Security",
					description: "Uses the Purple Knight tool to assess the security of your Active Directory environment.",
					permissions: ["purple-knight:read"],
					links: [
						{ label: 'Download Purple Knight', icon: 'tm:download', href: 'https://www.semperis.com/purple-knight/resources/' },
					],
				}
			},
			{
				path: "/report/domain-security",
				component: () => import("pages/report/DomainSecurityReportPage.vue"),
				meta: {
					title: "Domain Security",
					icon: "tm:domain",
					description: "View the SPF and DMARC status of external subdomains.",
					links: [
						{ to: '/external-scan' },
						{ to: '/dmarc/report' },
					],
				}
			},
			{
				path: "/report/executive",
				component: () => import("pages/report/ExecutiveReportPage.vue"),
				meta: {
					permissions: ["report:read"],
					title: "Executive Report",
				}
			},
			{
				path: "/report/prospect",
				component: () => import("pages/report/ProspectingReportPage.vue"),
				meta: {
					permissions: ["report:read"],
					title: "Attack Surface Report",
					description: "One score and a page per area: accounts, email, endpoints, Microsoft 365, external and internal network. Formerly the Prospecting Report.",
				}
			},
			{
				path: "/report/microsoft",
				component: () => import("pages/report/MicrosoftReportPage.vue"),
				meta: {
					permissions: ["report:read"],
					title: "Microsoft 365 Security & Configuration Report",
				}
			},
			{
				path: "/report/ai-risk",
				component: () => import("pages/report/AIRiskReportPage.vue"),
				meta: {
					// shadow-ai:read as well as report:read: every data call the
					// report makes is /v1/aitool/*, which the API gates on
					// shadow-ai:read, so report:read alone renders a page of 403s.
					// Armour-tier.
					permissions: ["report:read", "shadow-ai:read"],
					feature: "shadow-ai",
					isNew: true,
					title: "AI Risk Report",
					search: ["shadow ai", "ai risk", "ai governance", "ai tools"].join(" "),
				}
			},
			{
				path: "/report/dmarc-summary",
				component: () => import("pages/report/DmarcSummaryReportPage.vue"),
				meta: {
					// dmarc:read as well as report:read: every page of the report
					// reads /v1/dmarc/overview, which the API gates on dmarc:read.
					permissions: ["report:read", "dmarc:read"],
					title: "DMARC Summary Report",
					icon: "tm:dmarc-report",
					search: ["dmarc", "email authentication", "spoofing", "monthly report"].join(" "),
					links: [
						{ to: '/dmarc/report' },
						{ to: '/report/scheduled' },
						{ to: '/help/dmarc-summary-report' },
					],
				}
			},
			{
				path: "/report/hardening-evidence",
				component: () => import("pages/report/HardeningEvidenceReportPage.vue"),
				meta: {
					permissions: ["report:read", "endpoint-hardening:read"],
					title: "Configuration Hardening Evidence",
					description: "Point-in-time configuration hardening evidence for auditors and cyber-insurance underwriters: what was assessed and what was not, how settings were judged, the requirements each one evidences, per-device results, and any accepted risks.",
					// Same feature key as the Config Hardening fleet view, so
					// the badge follows the same upsell rules.
					feature: "endpoint-hardening",
					links: [
						{ to: '/help/config-hardening' },
					],
				}
			},
			{
				path: "/report/hardening-review",
				component: () => import("pages/report/HardeningReviewReportPage.vue"),
				meta: {
					permissions: ["report:read", "endpoint-hardening:read"],
					title: "Windows Security Hardening Review",
					description: "The client-facing hardening report: where the client's computers stand in plain language, which areas carry the risk, what to change next, which risks have been accepted, and what the assessment covered.",
					// Same feature key as the fleet view and the evidence
					// report, so the badge follows the same upsell rules.
					feature: "endpoint-hardening",
					links: [
						{ to: '/help/config-hardening' },
					],
				}
			},
			{
				path: "/report/hardening-plan",
				component: () => import("pages/report/HardeningPlanReportPage.vue"),
				meta: {
					permissions: ["report:read", "endpoint-hardening:read"],
					title: "Hardening Remediation Plan",
					description: "The internal working document for a change window: every failing setting batched into what can deploy now, what needs a pilot, and the long tail, with the projected score after each wave.",
					feature: "endpoint-hardening",
					links: [
						{ to: '/help/config-hardening' },
					],
				}
			},
			{
				path: "/report",
				component: () => import("src/pages/report/ReportLandingPage.vue"),
				meta: {
					permissions: ["report:read"],
					title: "Reports",
					icon: 'tm:report',
					description: "Reports are documents you send. Dashboards are pages you work in.",
					links: [
						{ to: '/report/scheduled' },
						{ to: '/report/builder' },
					],
				},
			},
			{
				path: "/report/builder",
				component: () => import("pages/report/ReportBuilder.vue"),
				meta: {
					permissions: ["report:read"],
					title: "Report Builder",
					description: "Build custom reports for your tenant.",
					icon: 'tm:report',
					beta: true,
					links: [
						{ to: '/report' },
					],
				}
			},
			{
				path: "/report/network-vulnerability",
				component: () => import("pages/report/NetworkVulnerabilityReportPage.vue"),
				meta: {
					permissions: ["report:read"],
					title: "Network Vulnerability Report",
					description: "View and print the network vulnerability report for your tenant.",
					icon: 'tm:report',
				},
			},
			{
				path: "/report/network-pentest",
				component: () => import("pages/report/NetworkPentestReportPage.vue"),
				meta: {
					permissions: ["report:read"],
					title: "Network Penetration Test Report",
					description: "View and print the network penetration test report for your tenant.",
					icon: 'tm:pentest',
				},
			},
			{
				path: "/report/endpoint",
				component: () => import("pages/report/EndpointReportPage.vue"),
				meta: {
					permissions: ["report:read"],
					title: "Endpoint Report",
					description: "View and print the endpoint findings report for your tenant.",
					icon: 'tm:report',
				},
			},
			{
				path: "/report/nist",
				component: () => import("pages/report/NistReportPage.vue"),
				meta: {
					title: "NIST CSF (Cybersecurity Framework) 2.0",
					beta: true,
				}
			},
			{
				path: "/report/security-score",
				component: () => import("pages/report/SecurityScoreReport.vue"),
				name: 'SecurityScoreReport',
				props: true,
				meta: {
					title: "Security Score",
					description: "View the security score for the current tenant.",
					links: [
						{ to: '/missionplan' }
					]
				}
			},
			{
				path: "/report/security-score/tenant",
				component: () => import("pages/report/SecurityScoreTenantsReport.vue"),
				meta: {
					title: "Multi-Tenant Security Scores",
					description: "This dashboard shows the scores for all first-level child tenants. If you don't have child tenants, no results will be displayed. Child tenants with additional children are aggregated into a single result.",
				}
			},
			{
				path: "/report/microsoft-score/",
				component: () => import("pages/report/MicrosoftScoreReport.vue"),
				name: 'MicrosoftScoreReport',
				props: true,
				meta: {
					title: "Microsoft Security Baseline",
					icon: 'tm:logo-microsoft',
					description: "View the Microsoft Security Baseline for the current tenant.",
					links: [
						{ to: '/integration/saas' },
					],
				}
			},
			{
				path: "/report/scheduled",
				component: () => import("src/pages/report/ScheduledReportsPage.vue"),
				name: "ScheduledReports",
				meta: {
					permissions: ["report:read"],
					title: "Scheduled Reports",
					icon: "tm:schedule",
					description: "Manage scheduled reports.",
					links: [
						{ to: '/help/scheduled-reports' },
					],
				}
			},
			{
				path: "/search",
				component: () => import("src/pages/SearchPage.vue"),
				meta: {
					title: "Search",
					icon: 'tm:search',
					description: "Search for pages, assets, breaches, etc.",
				}
			},
			{
				path: "/settings",
				component: () => import("src/pages/settings/LandingPage.vue"),
				meta: {
					title: "Settings",
					icon: 'tm:settings',
					tooltip: 'Manage your settings',
					description: "Manage your settings.",
				}
			},
			{
				path: "/settings/customer",
				component: () => import("src/pages/settings/CustomersPage.vue"),
				meta: {
					title: "Branding & Customers",
					description: "Manage branding and customers.",
					permissions: ["customer:read"],
				}
			},
			{
				path: "/settings/notificationrule",
				component: () => import("pages/notificationrule/NotificationRulesPage.vue"),
				meta: {
					title: "Notification Rules",
					description: "Manage the notification rules for this tenant.",
				}
			},
			{
				path: "/integration/senteon",
				component: () => import("src/pages/integration/senteon/DetailsPage.vue"),
				meta: {
					title: "Senteon",
				}
			},
			{
				path: "/settings/customer/:customerId",
				component: () => import("src/pages/settings/CustomerPage.vue"),
				meta: {
					title: "{customerName}",
					permissions: ["customer:read"],
				}
			},
			{
				path: "/settings/task",
				component: () => import("src/pages/settings/TasksPage.vue"),
				meta: {
					title: "Background Tasks",
					description: "Manage background tasks.",
				}
			},
			{
				path: "/settings/tenant",
				component: () => import("src/pages/settings/TenantPage.vue"),
				meta: {
					title: "Tenants",
					icon: 'tm:tenant',
					tooltip: "Manage tenants",
					permissions: ["segment:read"],
					description: "Manage your tenants.",
				}
			},
			{
				path: "/settings/tenant/:tenantId",
				component: () => import("src/pages/settings/TenantDetailsPage.vue"),
				meta: {
					title: "Tenant Details",
				}
			},
			{
				path: "/settings/settings",
				component: () => import("src/pages/settings/TenantSettingsPage.vue"),
				meta: {
					title: "Default Settings",
					description: "Fine-tune how the agent, scans, and discovery behave for this tenant. Switch tenants with the Tenant selector to adjust a lower level.",
					search: "patch deferral os application finding deferrals tenant settings default compliance frameworks config hardening framework soc 2 hipaa pci",
				}
			},
			{
				path: "/settings/auto-remediation",
				component: () => import("src/pages/settings/AutoRemediationSettingsPage.vue"),
				meta: {
					title: "Automated Remediation",
					icon: 'tm:auto-remediation',
					description: "Turn on hands-off patching and set the new-device remediation defaults for this tenant.",
					permissions: ["segment:read"],
					beta: true,
					search: "automated remediation patch auto-approve threshold exclude defaults",
					// See the note on /pii/dashboard; FEATURE_AUTOMATED_REMEDIATION.
					feature: "automated-remediation",
				}
			},
			{
				path: "/settings/user",
				component: () => import("src/pages/settings/UsersPage.vue"),
				meta: {
					title: "Users",
					icon: 'tm:user',
					tooltip: "Manage users",
					description: "Manage your users.",
					permissions: ["user:read"],
					links: [
						{ to: '/settings/userrole' },
					],
				}
			},
			{
				path: "/settings/userrole",
				component: () => import("src/pages/settings/UserRolesPage.vue"),
				meta: {
					title: "User Roles",
					icon: "tm:user-role",
					description: "Manage your user roles.",
					links: [
						{ to: '/settings/user' },
					],
				}
			},
			{
				path: "/settings/oidc-client",
				component: () => import("src/pages/settings/OidcClientPage.vue"),
				meta: {
					title: "OIDC Clients",
					icon: "tm:lock",
					tooltip: "Manage OIDC clients",
					description: "Manage the OIDC relying-party clients (SSO) that authenticate against ThreatMate.",
					permissions: ["oidc-client:read"],
				}
			},
			{
				path: "/settings/sso",
				component: () => import("src/pages/settings/SingleSignOnPage.vue"),
				meta: {
					title: "Single Sign-On",
					icon: "tm:vpn-key",
					tooltip: "Configure single sign-on",
					description: "Let your organization sign in to ThreatMate with your own identity provider (Okta, Entra ID, Google Workspace).",
					permissions: ["sso:read"],
					search: "sso single sign-on okta entra azure google oidc saml identity provider login",
				}
			},
			// Mission Plan Configuration
			{
				path: "/cve/solution/:id/:cveId",
				component: () => import("pages/missionplan/ViewSolutionPage.vue"),
				name: 'ViewSolutionPage',
				props: true,
			},

			// Threat Intel
			{
				path: "/threat-intelligence/known-exploited",
				component: () => import("src/pages/threat-intelligence/KnownExploited.vue"),
				meta: {
					title: "CISA",
				}
			},

			// Crown Jewels Pages
			{
				path: "/pii/dashboard",
				component: () => import("pages/pii/PIIRiskDashboardPage.vue"),
				name: 'PIIRiskDashboard',
				props: true,
				meta: {
					title: "Crown Jewels Risk Overview",
					icon: 'tm:shield',
					permissions: ["asset:read"],
					// Feature name from internal/featuregate/features.go (the
					// FEATURE_CROWN_JEWELS constant in useFeatureGate.js). TmPage and
					// TmMenuItem resolve it against the license cache to decide
					// whether to show a tier badge, and which tier to name.
					feature: "crown-jewels",
				}
			},
			{
				path: "/pii/dashboard/asset/:assetId(\\d+)",
				component: () => import("pages/pii/PiiAssetSummaryPage.vue"),
				name: 'PiiAssetSummaryPage',
				props: true,
				meta: {
					title: "Crown Jewels Asset Summary",
					permissions: ["asset:read"],
					// See the note on /pii/dashboard; FEATURE_CROWN_JEWELS.
					feature: "crown-jewels",
				}
			},
			{
				path: "/pii/findings/:assetId(\\d+)",
				component: () => import("pages/pii/PIIFindingsPage.vue"),
				name: 'PIIFindingsPage',
				props: true,
				meta: {
					title: "Crown Jewels Findings",
					permissions: ["asset:read"],
					// See the note on /pii/dashboard; FEATURE_CROWN_JEWELS.
					feature: "crown-jewels",
				}
			},
			{
				path: "/pii/datatype/:assetId(\\d+)",
				component: () => import("pages/pii/PiiDataTypeFindings.vue"),
				name: 'PiiDataTypeFindings',
				props: true,
				meta: {
					title: "Crown Jewels Data Type Findings",
					permissions: ["asset:read"],
					// See the note on /pii/dashboard; FEATURE_CROWN_JEWELS.
					feature: "crown-jewels",
				}
			},

			// Pen Test Pages
			{
				// Superseded by the finding page, which embeds this result's
				// evidence card alongside the severity, scores, fix guidance and
				// actions this page cannot offer. Kept, and badged deprecated by
				// tm-page, because old links and bookmarks still point here — a
				// redirect would need a resultId -> alert lookup the API does not
				// expose. Nothing in the product links here any more.
				path: "/pentest/details/:resultId",
				component: () => import("pages/pentest/PenTestDetailsPage.vue"),
				name: 'PenTestDetailsPage',
				props: true,
				meta: {
					title: "Penetration Test Details",
					deprecated: true,
					description: "Pentest results are shown on the finding itself, with the evidence, the scores and the fix in one place.",
					links: [
						{ to: '/alerts' },
						{ to: '/pentest/summary' },
					],
				}
			},
			{
				path: "/pentest/summary",
				component: () => import("pages/pentest/PenTestSummaryPage.vue"),
				name: 'PenTestSummaryPage',
				props: true,
				meta: {
					title: "Penetration Test Summary",
					// Every page that links here builds its action button from this
					// meta (see TmPage's link handling), so without an icon the
					// button arrives as bare text beside siblings that have one —
					// which is how the per-location pages were rendering it.
					icon: 'tm:pentest-dashboard',
					description: "Your network security posture, what the penetration test confirmed, and the fixes worth doing first.",
					// No /help/pentest-evidence here. The page carries a help
					// drawer, and a help article linked from the action bar as
					// well is two doors into the same room — the drawer's
					// Evidence section links it inline instead. A page with no
					// help section of its own is where that link earns a
					// button.
					links: [
						{ to: '/report/network-pentest' },
						{ to: '/external-scan' },
					],
				}
			},
			{
				path: "/pentest/summary/:assetLocation",
				component: () => import("pages/pentest/PenTestScanGroupSummaryPage.vue"),
				name: 'PenTestScanGroupSummaryPage',
				props: true,
				meta: {
					// The page passes tm-page a display label for the location, so
					// the last crumb reads "Internal network" rather than the raw
					// route token this template falls back to.
					title: "{assetLocation}",
					description: "The hosts tested at this location and the findings on each.",
					links: [
						{ to: '/pentest/summary' },
					],
				}
			},

			{
				path: "/progress-score",
				component: () => import("pages/progress-score/ProgressScorePage.vue"),
				name: 'ProgressScorePage',
				props: true,
				meta: {
					title: "Progress Score",
				}
			},

			{
				path: "/register-hardware",
				component: () => import("pages/agent-hardware/RegisterHardwarePage.vue"),
				name: 'RegisterHardwarePage',
				props: true,
				meta: {
					title: "Register Hardware",
				}
			},

			// Surveys
			{
				path: "/survey",
				component: () => import("pages/survey/SurveySummaryPage.vue"),
				meta: {
					title: "Surveys",
					icon: 'tm:survey',
					tooltip: "Manage surveys and view survey results",
					permissions: ["survey:read"],
					beta: true,
				}
			},
			{
				path: "/survey/:surveyId/:responseId?",
				component: () => import("pages/survey/SurveyPage.vue"),
				name: 'SurveyPage',
				props: true,
				meta: {
					title: "{surveyName}",
				}
			},
			{
				path: "/survey/:surveyId/assignments",
				component: () => import("pages/survey/SurveyAssignmentsPage.vue"),
				name: 'SurveyAssignmentsPage',
				meta: {
					title: "Assignments",
				}
			},
			{
				path: "/survey/:surveyId/report",
				component: () => import("pages/survey/SurveyReportPage.vue"),
				name: 'SurveyReportPage',
				props: true,
				meta: {
					title: "Report",
				}
			},
			{
				// Isn't a standard page, doesn't use tm-page
				path: "/connectwise-mission-plan/debug",
				component: () => import("pages/integration/connectwise/pod/MissionPlanSummaryPage.vue"),
			},
			{
				// Isn't a standard page, doesn't use tm-page
				path: "/connectwise-mission-plan/debug/:subsystem",
				component: () => import("pages/integration/connectwise/pod/MissionPlanSummaryPage.vue"),
			},
			{
				// Isn't a standard page, doesn't use tm-page
				path: "/connectwise-mission-plan/debug/:subsystem/:subsystemFilter",
				component: () => import("pages/integration/connectwise/pod/MissionPlanSummaryPage.vue"),
			},
		],
	},
	{
		path: "/",
		component: () => import("layouts/ConnectWiseMissionPlanLayout.vue"),
		meta: {
			requiresAuth: false, // This page is specifically designed to do it's own authentication for pods. Only works for CW pods
		},
		children: [
			{
				path: "/connectwise-pod",
				component: () => import("pages/integration/connectwise/pod/AuthenticationPage.vue"),
			}
		]
	},
	{
		path: "/",
		component: () => import("layouts/ConnectWiseMissionPlanLayout.vue"),
		meta: {
			requiresAuth: true, // Require authentication.
		},
		children: [
			{
				path: "/connectwise-mission-plan",
				component: () => import("pages/integration/connectwise/pod/MissionPlanSummaryPage.vue"),
			},
			{
				path: "/connectwise-mission-plan/:subsystem",
				component: () => import("pages/integration/connectwise/pod/MissionPlanSummaryPage.vue"),
			},
			{
				path: "/connectwise-mission-plan/:subsystem/:subsystemFilter",
				component: () => import("pages/integration/connectwise/pod/MissionPlanSummaryPage.vue"),
			},
		]
	},
	// Always leave this as the last one, which renders a 404 page.
	{
		path: "/:catchAll(.*)*",
		component: () => import("pages/Error404Page.vue"),
	},
]

export default routes
